import { BaseAction } from "../../../core/actions/BaseAction";
import { getRecoilStateValue, getRecoilStateValueWithType, updateRecoilStateWithType } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IPassenger, SearchRequestType } from "../../../Orchestrator/Types/Index";
import { TrainType } from "../../../Orchestrator/Types/Types/TrainTypes";
import dayjs from "dayjs";
import { getSearchResultAction } from "../Search/GetSearchResultAction";
import { isActionRunSuccessfully } from "../../../Lib/Utils/validationUtil";

export interface IGetChangeTrainOfferActionParams {
  trainType: TrainTypeEnum,
  tripDate: dayjs.Dayjs
}

class GetTrainChangeOfferAction extends BaseAction<void, IGetChangeTrainOfferActionParams> {
  async run(): Promise<void> {
    const { trainType, tripDate } = this.params!;
    const multiBookingFormValuesState = getRecoilStateValueWithType("multiBookingFormValuesAtom")

    if (multiBookingFormValuesState && tripDate) {
      const origin = trainType === TrainTypeEnum.outbound ? multiBookingFormValuesState.preferredOrigin : multiBookingFormValuesState.preferredDestination
      const destination = trainType === TrainTypeEnum.outbound ? multiBookingFormValuesState.preferredDestination : multiBookingFormValuesState.preferredOrigin

      const searchRequestState: SearchRequestType = {
        departureTime: tripDate.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
        origin: origin!,
        destination: destination!,
        totalPassengerCount: 1,
        passengerCounts: {
          [multiBookingFormValuesState.passengerType as string]: 1
        },
        trainType: trainType,
      }

      updateRecoilStateWithType("multiBookingChangeTrainOffersAtom", null)

      const passengersState = getRecoilStateValue<IPassenger[]>("passengerStateAtom")
      getSearchResultAction.setParams({
        ...searchRequestState,
        selectedTripPassenger: passengersState,
        prefillSelectedTripPassenger: true
      });
      try {
        await getSearchResultAction.execute();

        if (isActionRunSuccessfully(getSearchResultAction)) {
          const result = getSearchResultAction.result;
          if (result?.result === "true") {
            updateRecoilStateWithType("multiBookingChangeTrainOffersAtom", result?.data || [])
            return;
          }
        }
      } catch { }

      updateRecoilStateWithType("multiBookingChangeTrainOffersAtom", [])
    }
  }
}

export const getTrainChangeOfferAction = new GetTrainChangeOfferAction();
